export default class Comment {
	constructor(gameID, text, time, type) {
		this.gameID = gameID;
		this.text = text;
		this.time = time;
		this.type = type;
	}
}
